import TYPES from '../../types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';
import { GenderEntity } from '../../domain/entities/gender-entity';
import StateManager from '../../domain/state/state-manager';
import SearchGendersRepository from '../../domain/repositories/search-genders-repository';

@Injectable()
export default class OnBoardingSearchGendersQuery extends Query<Array<GenderEntity>> {
  @Inject(TYPES.ON_BOARDING_CATALOGS_GENDERS_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.ON_BOARDING_CATALOGS_SEARCH_GENDERS_REPOSITORY)
  private readonly repository!: SearchGendersRepository;

  internalExecute() {
    if (!this.state_manager.state.loaded) {
      this.repository.findAll()
        .then((items) => {
          this.state_manager.patch({ items, loaded: true });
        });
    }

    return this.state_manager.state.items;
  }
}
